// extracted by mini-css-extract-plugin
export default {"item":"CardImage_item__i95gd","image":"CardImage_image__UmH4d","flareAnimation":"CardImage_flareAnimation__Jy4ni","shine":"CardImage_shine__+jHWK"};